import { REGIONS_BY_ID, type RegionId } from '@snootsvet/shared'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/frontend/components/ui/tooltip'
import { cn } from '@/frontend/lib/utils'

/** A small region flag emoji with the full region name shown on hover. */
export function RegionFlag({ region, className }: { region: RegionId; className?: string }) {
  const { flag, name } = REGIONS_BY_ID[region]
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            role="img"
            aria-label={name}
            className={cn('cursor-default select-none leading-none', className)}
          >
            {flag}
          </span>
        }
      />
      <TooltipContent>{name}</TooltipContent>
    </Tooltip>
  )
}
